import type { StoreWithDispatch } from '@ms/yammer-data';
import { realtimeLogger } from '@ms/yammer-data/dist/realtime/debugEventLog/middleware';
import createReduxStore from '@ms/yammer-data/dist/store/createStore';
import type { ReducersMapObject } from 'redux';
import type { YammerTeamsNativeState } from 'state/types';

import { persistConfig } from '../persistedState';

export type CreateStore = () => StoreWithDispatch<YammerTeamsNativeState>;

export const createStore: CreateStore = () => {
  const reducers: ReducersMapObject<Partial<YammerTeamsNativeState>> = {};

  return createReduxStore<YammerTeamsNativeState>({
    reducers,
    persistConfig,
    middleware: [realtimeLogger],
  }).store;
};
